// Common
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Modules
import { CommonModule as AppCommonModule } from '../common/common.module';
import { FormControlsModule } from '@modules/form-controls/form-controls.module';
import { UtilsModule } from '@modules/utils/utils.module';

// Services
import { SessionsService } from '@modules/account/services/sessions.service';

@NgModule({
  imports: [CommonModule, AppCommonModule, FormsModule, FormControlsModule, UtilsModule],
  providers: [
    // The four mail services this module used to provide now live in `space-context.directive.ts`, so
    // they hold the SCOPED `HttpClient`: this module is imported EAGERLY by the root module, so anything
    // provided here takes the ROOT client, which carries no spaces interceptor, and every
    // `/api/mail/*` request went out with no `space_id` in all three tenants (#1056).
    // `SessionsService` stays: it addresses `/api/account/sessions`, which is NOT in
    // `APP_TENANT_SCOPED_PREFIXES`, so unstamped is the correct behaviour for it.
    SessionsService,
  ],
})
export class AccountModule {}
